/**
 *    @author:
 *    @since:
 *
 */

import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData } from '../_common/data/input-data';
import { Path } from  "../_common/constant/page-const";
import { BeforeYouBeginValidation } from './before_you_begin.validator';

@Component({ 
      selector: 'before_you_begin',
      templateUrl: './before_you_begin.component.html',
      styleUrls: ['./before_you_begin.component.less'],
      //encapsulation: ViewEncapsulation.None
})
export class BeforeYouBeginComponent extends FormBaseComponent implements OnInit {

       // declare Field variable here
      orgContactPath = Path.ORGContactInformation;

      constructor( protected router: Router ,
                   public timerService:TimerService,
                   public data:InputData ) {

            super(router,timerService,null);  
            super.setNextPage(Path.Setup1,Path.Start);
            super.setValidator(new BeforeYouBeginValidation(this));

            InputData.currentPageIdx = 2;
            if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
      }

      public ngOnInit() {
             super.forwardNext(this.data.eligibility.listedParentCount);
      }
}
